<button
	(click)="showNoCarriersRunLaneMsg()"
	*ngIf="useButton"
	[disabled]="disabled"
	[matTooltip]="tooltipText"
	color="primary"
	mat-raised-button
	matTooltipClass="custom-tooltip"
>
	{{ buttonText }}
</button>

<button
	(click)="showNoCarriersRunLaneMsg()"
	*ngIf="useMenuButton"
	class="primary-text"
	mat-menu-item
>
	{{ buttonText }}
</button>
